import type { ParsedUrl } from 'query-string';
import queryString from 'query-string';

export function getQueryStringValue(key: string): string | undefined {
  if (typeof window !== 'undefined') {
    const queryParams = queryString.parse(window.location.search);
    const queryParam = queryParams[key];
    if (Array.isArray(queryParam)) {
      return (queryParam.length > 0 && queryParam[0]) || '';
    }
    return queryParam || undefined;
  }
  return undefined;
}

export function getUrlWithNewQueryStringValue(key: string, value?: string): string {
  if (typeof window !== 'undefined') {
    return addQueryStringToUrl(window.location.href, key, value);
  }
  throw new Error(`Type of window is undefined`);
}

function addQueryStringToUrl(url: string, key: string, value?: string): string {
  const parsedUrl: ParsedUrl = queryString.parseUrl(url);
  if (value) {
    parsedUrl.query[key] = value;
  }
  return queryString.stringifyUrl(parsedUrl);
}

export function updateUrlPreservingQueryParams(
  targetPathName: string,
  options?: { excludedQueryParams?: string[]; newQueryParams?: [string, string][] }
): string {
  if (typeof window !== 'undefined') {
    let url = targetPathName + window.location.search;

    if (options?.excludedQueryParams) {
      url = queryString.exclude(url, options.excludedQueryParams);
    }

    (options?.newQueryParams ?? []).forEach(([key, value]) => {
      url = addQueryStringToUrl(url, key, value);
    });

    return url;
  }
  throw new Error(`Type of window is undefined`);
}
